import { TYPES } from "./event.actions";
import {
	createEmptyAutoCertificate,
	createEmptyCertificationSignature,
	getCertificationSignatureTypeDetail,
	hasDuplicateSignatureTypeForIndex,
	normalizeAutoCertificate,
	signatureRequiresSpeakerData,
} from "views/Eventos/utils/certification";

export const EVENT_FORM_INITIAL_STATE = {
	currentStep: 1,
	form: {
		step1: {
			part1: {
				title: "",
				description: "",
				standOutEvent: false,
			},
			part2: {
				eventTypeId: 0,
				eventSubtypeId: 0,
				eventGraphicId: 0,
				hasSubtype: false,
				hasSectionSubtype: false,
				complementaryServiceAreaId: 0,
				sectionSubtype: 0,
			},
			part3: {
				period: 0,
				hasWaitlist: false,
				duration: {
					onlyDay: {
						date: -1,
						time: {
							start: -1,
							end: -1,
						},
					},
					manyDays: {
						date: {
							start: -1,
							end: -1,
							waitlist: -1,
						},
						isValidWaitlist: false,
						isValidDaysCheckbox: false,
						days: [], // [1, 2, 5]
						time: [], // [{ dayId: 0, start: -1, end: -1 }]
					},
				},
			},
		},
		step2: {
			part1: {
				organizerId: 0,
				teacher: {
					search: {
						id: "",
						fullName: "",
					},
					free: {
						fullName: "",
						accountId: 0,
					},
				},
				payGradeId: "",
				placeOrganization: {
					campus: {
						id: 0,
						name: "",
					},
				},
			},
			part2: {
				locationId: 0,
				zoomTypeId: 0,
				zoomInscriptionTypeId: 0,
				place: {
					campus: {
						id: 0,
						name: "",
					},
					environment: {
						inCampus: {
							id: 0,
							address: "",
							floor: "",
						},
						outCampus: {
							internalOrExternal: "",
							address: "",
						},
					},
				},
			},
			part3: {
				quantityVacancy: "",
				publicLoad: {
					id: 0,
					students: {
						publicByCampusIds: [],
						modalityId: 0,
					},
					list: {
						studentsFile: {
							name: "",
							size: 0,
							base64: "",
						},
					},
				},
			},
			part4: {
				autoCertificate: createEmptyAutoCertificate(),
			},
		},
	},
	errors: {
		step1: {
			part1: {
				title: false,
				description: false,
			},
			part2: {
				eventTypeId: false,
				eventSubtypeId: false,
				eventGraphicId: false,
				payGradeId: false,
				complementaryServiceAreaId: false,
				sectionSubtype: false,
			},
			part3: {
				period: false,
				hasWaitlist: false,
				duration: {
					onlyDay: {
						date: false,
						time: {
							start: false,
							end: false,
						},
						areInvalidTimes: false,
					},
					manyDays: {
						date: {
							start: false,
							end: false,
							waitlist: false,
						},
						areInvalidDates: false,
						isValidWaitlist: false,
						isValidDaysCheckbox: false,
						days: false,
						time: [], // [{ id: 0, start: false, end: false, areInvalidTimes }]
					},
				},
			},
		},
		step2: {
			part1: {
				organizerId: false,
				teacher: {
					search: false,
					free: {
						fullName: false,
						accountId: false,
					},
					any: false,
				},
				placeOrganization: {
					campus: false,
				},
			},
			part2: {
				locationId: false,
				zoomInscriptionTypeId: false,
				zoomTypeId: false,
				place: {
					campus: false,
					environment: {
						inCampus: {
							envId: false,
							floor: false,
						},
						outCampus: {
							internalOrExternal: false,
							address: false,
						},
						any: false,
					},
				},
			},
			part3: {
				quantityVacancy: false,
				publicLoad: {
					id: false,
					students: {
						publicByCampusIds: false,
						modalityId: false,
					},
					list: {
						studentsFile: false,
					},
				},
			},
			part4: {
				autoCertificate: {
					signatureCount: false,
					signatures: false,
					duplicateTypes: false,
					invalidValidity: false,
					signatureItems: [],
				},
			},
		},
	},
	errorTexts: {
		publicLoadStudentsFile: "Es necesario que subas un archivo",
		teacherSearch: "",
		teacherFreeAccount: "No has seleccionado una cuenta.",
		zoomTypeId: "Es necesario seleccionar un rango de vacantes",
		autoCertificateSignatures:
			"Completa la cantidad de firmas y configura cada slot requerido.",
		autoCertificateTeacherSpeaker:
			"Completa o busca la información del docente / ponente.",
		autoCertificateValidity:
			"Existe al menos una firma institucional sin vigencia válida para el campus organizador y la fecha fin del evento.",
	},
};
//#region Functions
const changeFieldForm = (
	prev,
	step,
	{ part, field, value, errorValue = null }
) => {
	const obj =
		errorValue === null
			? {}
			: {
					[field]: errorValue,
			  };
	return {
		...prev,
		form: {
			...prev.form,
			[step]: {
				...prev.form[step],
				[part]: {
					...prev.form[step][part],
					[field]:
						typeof value === "function"
							? value(prev.form[step][part][field])
							: value,
				},
			},
		},
		errors: {
			...prev.errors,
			[step]: {
				...prev.errors[step],
				[part]: {
					...prev.errors[step][part],
					...obj,
				},
			},
		},
	};
};
const changeErrorFormForStep = (prev, step, value) => {
	return {
		...prev,
		errors: {
			...prev.errors,
			[step]:
				typeof value === "function" ? value(prev.errors[step]) : value,
		},
	};
};
const changeAllForm = (prev, form) => {
	const { errors } = EVENT_FORM_INITIAL_STATE;
	const { time } = form.step1.part3.duration.manyDays;
	return {
		...prev,
		form: {
			...form,
			step2: {
				...form.step2,
				part4: {
					autoCertificate: normalizeAutoCertificate(
						form.step2.part4?.autoCertificate
					),
				},
			},
		},
		errors: {
			...errors,
			step1: {
				...errors.step1,
				part3: {
					...errors.step1.part3,
					duration: {
						...errors.step1.part3.duration,
						manyDays: {
							...errors.step1.part3.duration.manyDays,
							time: time.map(({ dayId }) => ({
								dayId,
								start: false,
								end: false,
							})),
						},
					},
				},
			},
			step2: {
				...errors.step2,
				part4: {
					autoCertificate: {
						...errors.step2.part4.autoCertificate,
						signatureItems: normalizeAutoCertificate(
							form.step2.part4?.autoCertificate
						).signatures.map(() => ({
							signatureTypeCode: false,
							utpCode: false,
							fullName: false,
						})),
					},
				},
			},
		},
	};
};

const getAutoCertificateSignatureErrors = autoCertificate =>
	autoCertificate.signatures.map(() => ({
		signatureTypeCode: false,
		utpCode: false,
		fullName: false,
	}));

const setAutoCertificateState = (prev, autoCertificate) => {
	const normalized = normalizeAutoCertificate(autoCertificate);
	return {
		...prev,
		form: {
			...prev.form,
			step2: {
				...prev.form.step2,
				part4: {
					autoCertificate: normalized,
				},
			},
		},
		errors: {
			...prev.errors,
			step2: {
				...prev.errors.step2,
				part4: {
					autoCertificate: {
						...prev.errors.step2.part4.autoCertificate,
						signatureItems: getAutoCertificateSignatureErrors(normalized),
					},
				},
			},
		},
	};
};

const setAutoCertificateFieldState = (prev, field, value) => {
	const current = prev.form.step2.part4.autoCertificate;
	return setAutoCertificateState(prev, {
		...current,
		[field]: value,
	});
};

const setAutoCertificateEnabledState = (prev, enabled) => {
	if (!enabled) return setAutoCertificateState(prev, createEmptyAutoCertificate());
	return setAutoCertificateState(prev, {
		...prev.form.step2.part4.autoCertificate,
		enabled: true,
		signatureCount:
			prev.form.step2.part4.autoCertificate.signatureCount || 1,
		signatures:
			prev.form.step2.part4.autoCertificate.signatures.length > 0
				? prev.form.step2.part4.autoCertificate.signatures
				: [createEmptyCertificationSignature(0)],
	});
};

const setAutoCertificateSignatureState = (prev, index, value) => {
	const current = prev.form.step2.part4.autoCertificate;
	const currentSignature = current.signatures[index];
	if (!currentSignature) return prev;
	const nextTypeCode =
		typeof value.signatureTypeCode === "string"
			? value.signatureTypeCode
			: currentSignature.signatureTypeCode;
	if (
		hasDuplicateSignatureTypeForIndex(
			current.signatures,
			index,
			nextTypeCode
		)
	)
		return prev;
	const signatures = current.signatures.map((signature, signatureIndex) =>
		signatureIndex !== index
			? signature
			: (() => {
					const typeChanged =
						nextTypeCode !== signature.signatureTypeCode;
					const typeDetail =
						getCertificationSignatureTypeDetail(nextTypeCode);
					const baseSignature = typeChanged
						? createEmptyCertificationSignature(index)
						: signature;
					return {
						...baseSignature,
						...value,
						slotIndex: index,
						signatureTypeCode: nextTypeCode,
						signatureTypeId: nextTypeCode
							? value.signatureTypeId || typeDetail?.id || 0
							: 0,
						hierarchyWeight: nextTypeCode
							? typeDetail?.hierarchyWeight || 0
							: 0,
						positionCode: "",
						sourceStatus: nextTypeCode
							? value.sourceStatus ||
							  (signatureRequiresSpeakerData(nextTypeCode)
									? "PENDING_EVENT_TEACHER"
									: "PENDING")
							: "PENDING",
					};
			  })()
	);
	return setAutoCertificateState(prev, {
		...current,
		signatures,
	});
};
//#endregion

const reducer = (state, action) => {
	switch (action.type) {
		case TYPES.NEXT_STEP:
			return {
				...state,
				currentStep: state.currentStep + 1,
			};
		case TYPES.BACK_STEP:
			return {
				...state,
				currentStep: state.currentStep - 1,
			};
		case TYPES.TO_STEP:
			return {
				...state,
				currentStep: action.payload.step,
			};
		case TYPES.SET_FORM_STEP_1:
			return changeFieldForm(state, "step1", action.payload.entries);
		case TYPES.SET_FORM_STEP_2:
			return changeFieldForm(state, "step2", action.payload.entries);
		case TYPES.SET_AUTO_CERTIFICATION:
			return setAutoCertificateState(state, action.payload.value);
		case TYPES.SET_AUTO_CERTIFICATION_ENABLED:
			return setAutoCertificateEnabledState(
				state,
				action.payload.enabled
			);
		case TYPES.SET_AUTO_CERTIFICATION_FIELD:
			return setAutoCertificateFieldState(
				state,
				action.payload.field,
				action.payload.value
			);
		case TYPES.SET_AUTO_CERTIFICATION_SIGNATURE_COUNT:
			return setAutoCertificateFieldState(
				state,
				"signatureCount",
				action.payload.value
			);
		case TYPES.SET_AUTO_CERTIFICATION_SIGNATURE:
			return setAutoCertificateSignatureState(
				state,
				action.payload.index,
				action.payload.value
			);
		case TYPES.SET_FORM_ERRORS_STEP_1:
			return changeErrorFormForStep(state, "step1", action.payload.value);
		case TYPES.SET_FORM_ERRORS_STEP_2:
			return changeErrorFormForStep(state, "step2", action.payload.value);
		case TYPES.SET_FORM:
			const { form } = action.payload;
			return changeAllForm(state, form);
		case TYPES.SET_ERROR_TEXT:
			const { field, text } = action.payload;
			return {
				...state,
				errorTexts: {
					...state.errorTexts,
					[field]: text,
				},
			};
		default:
			return state;
	}
};

export default reducer;
